<div *ngIf="order" class="content-area">
  <h3 class="content-title">Order Summary</h3>

  <div class="summary-card">
    <!-- Package Header Section -->
    <div class="package-header-section">
      <div class="package-info-row">
        <div class="package-details">
          <div class="package-name">{{ order.washType }}</div>
        </div>
        <div class="package-price">{{ formatPrice() }}</div>
      </div>
      <div class="order-id-section">
        <span class="order-id-label">ORDER ID</span>
        <span class="order-id-number">{{ order.orderId }}</span>
      </div>
    </div>

    <div class="divider"></div>

    <!-- Purchase Info Grid -->
    <div class="purchase-info-grid">
      <!-- First Row -->
      <div class="info-row-container">
        <div class="info-column">
          <span class="info-label">DATE OF PURCHASE</span>
          <span class="info-value">{{ formatDate(order.dateTime) }}</span>
        </div>
        <div class="info-column">
          <span class="info-label">SOURCE</span>
          <span class="info-value">{{ order.source || 'Way.com' }}</span>
        </div>
      </div>

      <!-- Second Row -->
      <div class="info-row-container">
        <div class="info-column">
          <span class="info-label">TRANSACTION TYPE</span>
          <span class="info-value">{{ getSummaryTransactionType() }}</span>
        </div>
        <div class="info-column" *ngIf="isRewashOrder()">
          <span class="info-label">REWASH REASON</span>
          <span class="info-value">{{ getRewashReasonDisplay() }}</span>
        </div>
        <div class="info-column" *ngIf="isMembershipTransaction() && getPlanDisplay()">
          <span class="info-label">PLAN</span>
          <span class="info-value">{{ getPlanDisplay() }}</span>
        </div>
        <div class="info-column" *ngIf="isMembershipTransaction()">
          <span class="info-label">WASH COUNT / LIMIT</span>
          <span class="info-value">{{ getWashCountDisplay() }}</span>
        </div>
        <div class="info-column" *ngIf="isPrepaidWashBook()">
          <span class="info-label">TOTAL WASHES</span>
          <span class="info-value">{{ getPrepaidWashCountDisplay() }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
